import { Sender } from "../components/Sender";

/** The user flags that say whether someone can send InMail. */
export interface InmailCapabilityUser {
	id: number;
	hasLiSn?: boolean | null;
	hasLinkedinPremium?: boolean | null;
	unipile?: { salesNavigatorIsLoggedIn?: boolean | null } | null;
}

type CampaignSender = Pick<Sender, "type" | "userId" | "active" | "deactivated">;

/**
 * Whether one of the campaign's active LinkedIn senders can send an InMail (PREC-3897) — Sales
 * Navigator or LinkedIn Premium, read the way the sender table reads it (`getUserCapabilities`).
 * A campaign built for a colleague who connects such an account later is still allowed; the
 * builder only says so.
 */
export const hasInmailCapableSender = (
	senders: CampaignSender[] | undefined,
	users: InmailCapabilityUser[] | undefined
): boolean => {
	const capable = new Set(
		(users ?? [])
			.filter(
				(user) =>
					!!user.hasLiSn || !!user.unipile?.salesNavigatorIsLoggedIn || !!user.hasLinkedinPremium
			)
			.map((user) => user.id)
	);

	return (senders ?? []).some(
		(sender) =>
			sender.type === "linkedin" &&
			sender.active &&
			!sender.deactivated &&
			capable.has(sender.userId)
	);
};

/**
 * The builder's InMail caveat: true only once the users are known — a campaign whose senders are
 * still loading is not yet one without a capable sender.
 */
export const isInmailSenderMissing = (
	senders: CampaignSender[] | undefined,
	users: InmailCapabilityUser[] | undefined
): boolean => users !== undefined && !hasInmailCapableSender(senders, users);
